import React from "react";
import { Box, Tooltip } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ActionButton } from "@/js/components/Classrooms/ActionButton";
import { ChatButtonStatusIndicator } from "./ChatButtonStatusIndicator";

interface Props {
	hasUnreadMessages: boolean;
	isChatActive: boolean;
	handleClick: () => void;
	hideStatusCircle?: boolean;
	disabledChat?: boolean;
	borderColour?: string;
}

export function ChatButton(props: Props): JSX.Element {
	const { t } = useTranslation();
	const disabledTooltip = t("classroomDetails.chatNotSupportedInClass");

	return (
		<Tooltip label={disabledTooltip} aria-label={disabledTooltip} placement="bottom" hasArrow isDisabled={!props.disabledChat}>
			<Box position={"relative"}>
				{(!props.hideStatusCircle || props.hasUnreadMessages) && !props.disabledChat && (
					<ChatButtonStatusIndicator active={props.isChatActive} hasUnreadMessages={props.hasUnreadMessages} />
				)}
				<ActionButton
					label={t("classroomDetails.chatButton")}
					icon="fa-message-lines"
					handleClick={props.handleClick}
					disabled={props.disabledChat}
					testId="chat-button"
					borderColour={props.borderColour}
				/>
			</Box>
		</Tooltip>
	);
}
